import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ClrIconModule } from "@clr/angular";
import { PersonFormComponent } from "../person-form/person-form.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { Personen } from "../../../_shared/interfaces";
import { AlertService, IAlertType, PersonsStoreService } from "../../../_shared/services";

import { environment as env } from "../../../../environments/environment";
import { map, switchMap, tap } from "rxjs/operators";
import {JsonPipe, NgIf} from "@angular/common";

@Component({
  selector: 'app-person-add',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    PersonFormComponent,
    JsonPipe,
    NgIf
  ],
  templateUrl: './person-add.component.html',
  styleUrl: './person-add.component.sass'
})
export class PersonAddComponent {
  personForm: FormGroup;
  companyId: number = 0;
  devMode: boolean;

  constructor(
    private fb: FormBuilder,
    private perss: PersonsStoreService,
    private router: Router,
    private route: ActivatedRoute,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;

    this.personForm = this.fb.group({
      pid: 0,
      cid: 0,
      crm_id: [''],
      salutation: [''],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      active: true,
      city: [''],
      country: ['DE'],
      email2: ['', [Validators.email]],
      email3: ['', [Validators.email]],
      mobile: [''],
      phone: [''],
      position: [''],
      postcode: [''],
      region: [''],
      street: [''],
    });
  }

  ngOnInit() {
    this.route.paramMap.pipe(
      map(params => parseInt(params.get('cid') ?? '0', 10)),
      tap((cid: number) => this.companyId = cid) // Use tap to modify the variable without affecting the Observable flow
    ).subscribe();
  }

  onSubmit(): void {
    if (this.personForm.valid) {
      this.createPerson(this.personForm.value);
      this.personForm.reset();
    }
  }

  createPerson(person: Personen) {
    person.country = this.normalizeCountry(person.country);
    person.crm_id = this.normalizeOptionalInteger(person.crm_id);
    this.perss.createPerson(person, this.companyId)
      .subscribe({
        next: (response) => {
          const newPerson = response.message;
          this.alertDispatcher.show({
            message: 'Person ' + person.firstname + ' ' + person.lastname + ' (' + newPerson + ') wurde angelegt!',
            clrAlertType: IAlertType.INFO
          }, 2000);

          this.router.navigate([`person/details/${newPerson}`]);

        },
        complete: () => {
        },
        error: () => {
          return
        }
      })
  };

  private normalizeCountry(country?: string | null): string {
    if (!country) return '';
    const trimmed = country.trim();
    if (trimmed.length === 2) {
      return trimmed.toUpperCase();
    }
    const map: Record<string, string> = {
      Belgien: 'BE',
      Dänemark: 'DK',
      Deutschland: 'DE',
      Frankreich: 'FR',
      Italien: 'IT',
      Kroatien: 'HR',
      Luxemburg: 'LU',
      Niederlande: 'NL',
      Österreich: 'AT',
      Polen: 'PL',
      Russland: 'RU',
      Schweden: 'SE',
      Schweiz: 'CH',
      Slowakei: 'SK',
      Slowenien: 'SI',
      Tschechien: 'CZ'
    };
    return map[trimmed] || trimmed;
  }

  private normalizeOptionalInteger(value: unknown): number | null {
    if (value === null || value === undefined || value === '') return null;
    const parsed = parseInt(String(value), 10);
    return Number.isFinite(parsed) ? parsed : null;
  }
}
